/**
 * Configuration for jobs in this app.
 */
const jobiqoJobsConfig = require('./../jobs');
const R = require('ramda');

module.exports = R.mergeDeepRight(jobiqoJobsConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    GEO_INFO: {
      fixtures: [
        {label: 'Palm Springs, CA, USA', location: {lat: 33.8302961, lng: -116.5452921}},
        {label: 'Desert Hot Springs, CA, USA', location: {lat: 33.9611243, lng: -116.503304}},
        {label: 'Cathedral City, CA, USA', location: {lat: 33.7797433, lng: -116.4652921}},
        {label: 'Rancho Mirage, CA, USA', location: {lat: 33.739744, lng: -116.412974}},
        {label: 'Palm Desert, CA, USA', location: {lat: 33.7222445, lng: -116.3744556}},
        {label: 'Indian Wells, CA, USA', location: {lat: 33.717356, lng: -116.339768}},
        {label: 'La Quinta, CA, USA', location: {lat: 33.6633573, lng: -116.3100095}},
        {label: 'Indio, CA, USA', location: {lat: 33.7205771, lng: -116.2155619}},
        {label: 'Coachella, CA, USA', location: {lat: 33.6803003, lng: -116.173894}},
      ],
    },
  },
});
